import { ELinks } from '@sharedInterfaces/globalEnums';
import { useDialog } from '@src/App/Components/Dialogs/DialogManager';
import OnboardingWelcomeDialog from '@src/App/Components/Dialogs/OnboardingWelcomeDialog/OnboardingWelcomeDialog';
import { isLoggedIn } from '@store/reducer/clientReducer';
import { selectCurrentUserOnboardingTalk } from '@store/reducer/employeeTalksReducer';
import type { AppState } from '@store/store';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

export default function OnboardingWelcomeHandler() {
    const { openDialog } = useDialog();
    const location = useLocation();
    const navigate = useNavigate();
    const loggedIn = useSelector((state: AppState) => isLoggedIn(state.client.secret));
    const onboardingTalk = useSelector(selectCurrentUserOnboardingTalk);
    const employee = useSelector((state: AppState) => state.employee);
    const [dialogShown, setDialogShown] = useState(false);

    useEffect(() => {
        if (!onboardingTalk || !loggedIn || dialogShown) return;
        if (onboardingTalk.employeeConfirmed) return;

        // Nicht auf Onboarding-Routen anzeigen
        const isOnboardingRoute =
            location.pathname.startsWith('/onboarding') || location.pathname.includes('/employee-talks/');
        if (isOnboardingRoute) return;

        const showDialog = () => {
            setDialogShown(true);

            // Berechne Progress aus talkState
            const currentStep = onboardingTalk.talkState?.navigation?.currentStep || 0;
            const totalSteps = 9; //onboardingTalk.talkState?.;
            const progress = currentStep > 0 ? Math.round(((currentStep + 1) / totalSteps) * 100) : 0;

            openDialog(
                <OnboardingWelcomeDialog
                    firstName={employee?.firstName || 'User'}
                    isCompleted={onboardingTalk.employeeConfirmed}
                    progress={progress}
                    currentStep={currentStep}
                    totalSteps={totalSteps}
                    onStart={() => {
                        navigate(`/${ELinks.EMPLOYEE_TALKS}/${onboardingTalk.id}`);
                    }}
                    onContinue={() => {
                        navigate(`/${ELinks.EMPLOYEE_TALKS}/${onboardingTalk.id}`);
                    }}
                    onClose={() => {
                        // Dialog schließt sich automatisch
                    }}
                />,
            );
        };

        const timeout = setTimeout(showDialog, 1000);
        return () => clearTimeout(timeout);
    }, [onboardingTalk, loggedIn, location.pathname, dialogShown, openDialog, navigate, employee]);

    return null;
}
